<template>
    <!-- 标签对应诗词页面 -->
    <div class="tag-page">
        <!-- 头部 -->
        <Header :name="name"/>

        <!-- 诗词列表 -->
        <PoemList :poems="poems"/>
    </div>
</template>

<script>
    import {GetPoemByTagId} from "@/request/poem";
    import Header from "./children/Header";
    import PoemList from './children/PoemList'

    export default {
        name: "TagPage",
        components:{
            Header,
            PoemList
        },
        created(){
            // TODO 1. 指定导航栏类型
            this.$store.commit("nav/typeUpdate",2);
            // TODO 2. 获取路由参数
            this.id = this.$route.params.id;
            // TODO 3. 获取标签信息
            this.name = this.$route.params.name;
            this.id = this.$route.params.id;
            // TODO 4. 获取诗词列表
            GetPoemByTagId({
                tagId:this.id,
                pageNum:1,
                pageSize:15
            }).then(res => {
                if (res.code === 200){
                    this.poems = res.data.list;
                }
            })
        },
        data(){
            return{
                id:"",
                name:"",
                poems:[]
            }
        }
    }
</script>

<style scoped lang="less">
    .tag-page{
        margin-top: 83px;
    }
</style>